import { motion } from "framer-motion";

const COLOR_BY_KEY = {
  clarity: "#D4AF37",
  constraints: "#1E40AF",
  efficiency: "#D4AF37",
  resilience: "#1E40AF",
};

export function CriteriaBar({ criterionKey, label, value, delay = 0 }) {
  const v = Math.max(0, Math.min(10, Number(value) || 0));
  const pct = (v / 10) * 100;
  const color = COLOR_BY_KEY[criterionKey] || "#D4AF37";

  return (
    <div
      className="grid grid-cols-[1fr_auto] gap-x-3 gap-y-1.5 items-center"
      data-testid={`criteria-${criterionKey}`}
    >
      <span className="text-xs uppercase tracking-[0.16em] text-white/55">
        {label}
      </span>
      <span
        className="text-sm font-semibold tabular-nums text-white"
        data-testid={`criteria-${criterionKey}-value`}
      >
        {v.toFixed(1)}
      </span>
      <div
        className="col-span-2 h-1.5 rounded-full bg-white/8 overflow-hidden"
        aria-hidden
      >
        <motion.div
          className="h-full rounded-full"
          style={{ background: color }}
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.7, delay, ease: [0.22, 0.9, 0.36, 1] }}
        />
      </div>
    </div>
  );
}

export default CriteriaBar;
